import React from 'react';
import {
  ButtonToolbar,
  Button,
  DropdownButton,
  MenuItem,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import styles from './ActionToolbar.css';

const ActionToolbar = ({
  actions = [],
  divider = false
}) => {
  return (
    <div className={divider ? styles.wrapperWithDivider : styles.wrapper}>
      <ButtonToolbar>
        {
          actions.map((action, idx) => {
            if (Array.isArray(action.children) && action.children.length) {
              return (
                <DropdownButton
                  key={idx}
                  title={action.title}
                  id={action.id}>
                  {
                    action.children.map(child => {
                      return (
                        <MenuItem
                          eventKey={child.id}
                          key={child.id}
                          {...child}>{child.title}</MenuItem>
                      );
                    })
                  }
                </DropdownButton>
              );
            } else {
              const isAlignRight = !!action.alignRight;
              delete action.alignRight;
              return (
                <Button
                  {...action}
                  className={isAlignRight ? 'pull-right': ''}
                  key={idx}>
                  {action.title}
                </Button>
              );
            }
          })
        }
      </ButtonToolbar>
    </div>
  );
};

const _props = {
  disabled: PropTypes.bool,      
  href: PropTypes.string,
  id: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string,
};

ActionToolbar.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.shape({
    alignRight: PropTypes.bool,
    children: PropTypes.arrayOf(PropTypes.shape(_props)),
    ..._props
  })),
  divider: PropTypes.bool,
};

export default ActionToolbar;
